import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigSelectableColumn} from '@src/@interfaces/components/List/IListConfigSelectableColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import trans from '@src/helpers/trans';

export default class SelectableColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigSelectableColumn>, Model> {
    protected get value(): any {
        const value = super.value ?? this.config.default ?? null;
        const options = this.config.options;

        if (options && ((value ?? 'null') in options)) {
            const result = options[(value ?? 'null') as keyof typeof options];
            // noinspection SuspiciousTypeOfGuard
            if (result != null && typeof result === 'string') {
                return trans(result);
            }

            return result;
        }

        return value;
    }
}
